import { useContext } from 'react';

import OrganizationContext, { IOrganizationContext } from './OrganizationContext';

export default function useOrganization() {
  return useContext<IOrganizationContext>(OrganizationContext);
}
